import BaseModelAPI from '../BaseModelAPI';

export default class BloodType extends BaseModelAPI {
	static entity = 'bloodtype';
	static entityName = 'bloodtype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}